
import { 
	call, 
	takeLatest, 
	put 
} from 'redux-saga/effects'

import {
  SEND_EMAIL_TO_PRODUCER,
  SEND_EMAIL_TO_PRODUCER_SUCCESS,
  SEND_EMAIL_TO_PRODUCER_FAIL
} from './Constants'

import Notification from "../../components/commons/Notification"

function* sendEmail(action) {
	const { name, email, phone_number } = action.payload.body
  return yield fetch(
    process.env.REACT_APP_EMAIL_API_URL,
    {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer '+process.env.REACT_APP_EMAIL_API_KEY
			},
			mode: 'cors',
			body: JSON.stringify({
				from: 'hello@intivastudio.com',
				to: ["andresreggi@gmail.com", "enzo@intivastudio.com", "jenny@intivastudio.com"],
				replyTo: email,
				subject: `Pedido de cotización de: ${name}`,
				html: `<p><strong>Pedido de cotización de:</strong> ${name}</p>
				       <p><strong>Email:</strong> ${email}</p>
				       <p><strong>Celular:</strong> ${phone_number}</p>`
			})
    }
  )
}

export function* shootFetchSendEmail(action) {
  try {
		yield console.log(action)
    const response  = yield call(sendEmail, action)
		const emailData = yield response.json()
		let type
    if (response.status >= 200 && response.status < 300) {
      type = SEND_EMAIL_TO_PRODUCER_SUCCESS
			yield Notification('Pedido de cotización enviado', 'success')
    }
    else {
	  	type = SEND_EMAIL_TO_PRODUCER_FAIL
	 		yield Notification(`Tuvimos un problema: ${response.statusText}`, 'error')
    }
		yield put({type: type, payload: emailData})
  }
  catch (error) {
    yield put({ type: SEND_EMAIL_TO_PRODUCER_FAIL, payload: error.message})
		yield Notification(`Tuvimos un problema: ${error.message}`, 'error')
  }
}

export default function* sendEmailWatcher() {
  yield takeLatest(SEND_EMAIL_TO_PRODUCER, shootFetchSendEmail)
}
